import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { BatchType, defaultBatchTypeDataForm } from '../../../app/models/BatchType';
import useBatchTypeService from '../../../app/services/hooks/useBatchTypeService';
import BatchTypeFormContainer from './BatchTypeFormContainer';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const BatchTypeCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [errorGetData, setErrorGetData] = useState('');
    const [batchType, setbatchType] = useState<BatchType>(defaultBatchTypeDataForm);

    const [errorFields, setErrorFields] = useState<any>();

    const { fetchingStoreBatchType, fetchingCreateBatchType, createBatchType, storeBatchType } = useBatchTypeService();


    useEffect(() => {
        if (showLoading) showLoading('loading', 'Cargando datos...');

        createBatchType({
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    }, []);

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando tipo de lote...');
        storeBatchType(batchType, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return (
        <BatchTypeFormContainer
            fetching={fetchingStoreBatchType}
            action={store}
            cancel={cancel}
            batchType={batchType}
            setBatchType={setbatchType}
            errorFields={errorFields}
        />
    );
};

export default BatchTypeCreate;
